// src/files.ts
var DROPZONE_ACCEPTED_TYPES = {
  "image/png": [".png", ".PNG"],
  "image/jpeg": [".jpeg", ".jpg", ".JPEG", ".JPG"],
  "image/tiff": [".tiff", ".TIFF"],
  "image/webp": [".webp", ".WEBP"],
  "image/heic": [".heic", ".HEIC"],
  "image/heif": [".heif", ".HEIF"],
  "application/pdf": [".pdf", ".PDF"]
};
var RESTRICTED_CONTENT_TYPES = {
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  tiff: "image/tiff",
  webp: "image/webp",
  heic: "image/heic",
  heif: "image/heif",
  pdf: "application/pdf"
};
var ALL_CONTENT_TYPES = {
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  tiff: "image/tiff",
  webp: "image/webp",
  heic: "image/heic",
  heif: "image/heif",
  pdf: "application/pdf",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  odp: "application/vnd.oasis.opendocument.presentation",
  ods: "application/vnd.oasis.opendocument.spreadsheet",
  ppt: "application/vnd.ms-powerpoint",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  zip: "application/zip"
};
var CONTENT_TYPE_TO_EXTENSION = Object.fromEntries(
  Object.entries(ALL_CONTENT_TYPES).map(([ext, type]) => [type, ext])
);
export {
  ALL_CONTENT_TYPES,
  CONTENT_TYPE_TO_EXTENSION,
  DROPZONE_ACCEPTED_TYPES,
  RESTRICTED_CONTENT_TYPES
};
//# sourceMappingURL=files.mjs.map